import { config } from "../../Config";

const deleteExtension = async (userId, extensionId, removeImage = false) => {
    const url = config.deleteExtension;

    try {
        const response = await fetch(url, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ userId, extensionId, removeImage }),
        });

        if (!response.ok) {
            const errorData = await response.json().catch(() => ({}));
            throw new Error(
                errorData.error || `DeleteExtension failed with status ${response.status}`
            );
        }

        const data = await response.json().catch(() => ({}));
        return { success: true, data };
    } catch (error) {
        // console.error("Error deleting extension:", error);
        return { success: false, error: error.message };
    }
};

export default deleteExtension;
